import React, { useEffect, useState } from 'react';
import chroma from 'chroma-js';
// 不传入Provider时的默认值
// 注意，考虑到stories能跑起来，所以这里都是各种try catch了
const defaultState = {
  backgroundColor: (() => {
    let color = '#ffffff';
    try {
      color = window.configDetail.theme.background;
    } catch (e) {}
    return color;
  })(),
  h1Color: (() => {
    let c = '#333333';
    try {
      c = window.configDetail.theme.h1;
    } catch (e) {}
    return c;
  })(),
  h2Color: (() => {
    let c = chroma('#333333')
      .alpha(0.5)
      .css();
    try {
      c = chroma(window.configDetail.theme.h1)
        .alpha(0.4)
        .css();
    } catch (e) {}
    return c;
  })(),
  componentColor: (() => {
    let c = '#fff';
    try {
      c = window.configDetail.theme.component;
    } catch (e) {}
    return c;
  })(),
  mainColor: (() => {
    let c = '#50d3cd';
    try {
      c = window.configDetail.theme.main;
    } catch (e) {}
    return c;
  })(),
  setTheme: (c1: string, c2: string, c3: string, c4: string, c5: string) => {}
};
export const ThemeContext = React.createContext(defaultState);
interface IThemeProvider {
  children: React.ReactChild;
}
const ThemeProvider = function(props: IThemeProvider) {
  const [backgroundColor, setBackgroundColor] = useState(
    defaultState.backgroundColor
  );
  const [h1Color, setH1Color] = useState(defaultState.h1Color);
  const [h2Color, setH2Color] = useState(defaultState.h2Color);
  const [componentColor, setComponentColor] = useState(
    defaultState.componentColor
  );
  const [mainColor, setMainColor] = useState(defaultState.mainColor);
  const setTheme = (
    bg: string,
    h1: string,
    cc: string,
    main: string,
    h2: string
  ) => {
    setBackgroundColor(bg);
    setH1Color(h1);
    setComponentColor(cc);
    setMainColor(main);
    setH2Color(h2);
  };
  // 浅色主题
  const setTheme1 = () =>
    setTheme(
      defaultState.backgroundColor,
      defaultState.h1Color,
      defaultState.componentColor,
      defaultState.mainColor,
      defaultState.h2Color
    );
  // 深色主题
  // const setTheme2 = () => setTheme('#333', '#fff', '#2a2a2a');

  useEffect(() => {

  }, []);

  return (
    <ThemeContext.Provider
      value={{
        backgroundColor,
        h1Color,
        h2Color,
        componentColor,
        mainColor,
        setTheme
      }}
    >
      {props.children}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;
